// Copyright (c) 2016 Deere & Company

import creditMemo from '../claims/reports/credit-memo';
import {hasAccess} from '../../shared/services/security';

export default security => {

    const offlineReports = {
        childRoutes: []
    };

    if (hasAccess(security, 'CLAIM', 'CLM_CREDIT_MEMO')) {

        offlineReports.childRoutes.push(creditMemo);

    }

    return offlineReports;

};



// WEBPACK FOOTER //
// ./src/routes/offline-reports/index.js